import { useState, useEffect } from 'react'
import { Outlet, useMatches, useLocation } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Topbar } from './Topbar'
import { hasWorkspaceLayout } from './workspaceRoute'
import { AiAssistantWidget } from '@/features/aiAssistant/AiAssistantWidget'

export function AppShell() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false)
  const workspace = hasWorkspaceLayout(useMatches())
  const location = useLocation()

  // Close mobile navigation drawer whenever route/path changes
  useEffect(() => {
    setMobileNavOpen(false)
  }, [location.pathname])

  return (
    <div className="flex h-full min-h-0 overflow-hidden bg-[var(--color-bg)] print:h-auto print:min-h-0 print:overflow-visible">
      {/* Chrome only — never include MENU / search / user strip in print output */}
      {/* Desktop Sidebar (hidden on mobile < 768px) */}
      <div className="hidden md:flex print:hidden">
        <Sidebar />
      </div>

      {/* Mobile Drawer Navigation (< 768px) */}
      {mobileNavOpen && (
        <div
          className="fixed inset-0 z-50 flex md:hidden print:hidden"
          role="dialog"
          aria-modal="true"
        >
          {/* Semi-transparent Backdrop */}
          <div
            className="fixed inset-0 bg-black/60 transition-opacity"
            onClick={() => setMobileNavOpen(false)}
            aria-hidden="true"
          />
          {/* Drawer Panel */}
          <div className="relative flex w-[min(300px,85vw)] flex-col bg-[var(--color-sidebar)] shadow-2xl z-10">
            <Sidebar isMobile onClose={() => setMobileNavOpen(false)} />
          </div>
        </div>
      )}

      <div className="flex min-w-0 flex-1 flex-col print:block print:w-full">
        <div className="print:hidden">
          <Topbar onToggleMobileNav={() => setMobileNavOpen((prev) => !prev)} />
        </div>
        <main
          className={`min-h-0 min-w-0 flex-1 overflow-x-hidden ${workspace ? 'overflow-y-hidden' : 'overflow-y-auto'} bg-[var(--color-bg)] print:h-auto print:overflow-visible`}
        >
          <div
            className={`${workspace ? 'flex h-full min-h-0 flex-col' : 'min-h-full'} min-w-0 max-w-full p-2 sm:p-4 md:p-[var(--space-page)] print:p-0`}
          >
            <Outlet />
          </div>
        </main>
      </div>
      <AiAssistantWidget />
    </div>
  )
}
